<script>
import { orderReportMethods, userMethods } from '@state/helpers'
import constant from '@constants/constant'
import common from '@state/modules/common'
import accesslevels from '@utils/accesslevels'

export default {
  props: {
    customerId: {
      type: [Number, String],
      default: '',
    },
    customerUserId: {
      type: [Number, String],
      default: '',
    },
    productId: {
      type: [Number, String],
      default: '',
    },
    productAddOns: {
      type: Array,
      default: Array,
    },
  },
  data() {
    return {
      errorLog: '',
      displayAlert: false,
      alertMessage: '',
      loanIdentifier: '',
      firstName: '',
      middleName: '',
      lastName: '',
      companyName: '',
      streetAddress: '',
      cityName: '',
      state: '',
      stateCode: '',
      zip: '',
      phoneNumber: '',
      legaldescription: '',
      coborrowerFirstName: '',
      coborrowerMiddleName: '',
      coborrowerLastName: '',
      coborrowerSelected: false,
      showSpinner: false,
      productAddon: [],
      productAddons: [],
      borrowerType: 1,
      isCustRequestor: false,
      typeOption: [
        { text: 'Business', value: 1 },
        { text: 'Individual', value: 2 },
      ],
    }
  },
  computed: {
    placeholders() {
      return {
        loanIdentifier: 'Loan Identifier',
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        streetAddress: 'Street Address',
        cityName: 'City Name',
        state: 'Select State',
        zip: 'xxxxx-xxxx',
        companyName: 'Company Name',
        phoneNumber: '(xxx) xxx-xxxx',
        legaldescription: 'Legal Description',
      }
    },

    states() {
      return this.$_allStates
    },
  },
  mounted() {
    this.getFloodReportAddons()
    this.isCustRequestor = accesslevels(9)
  },
  methods: {
    ...orderReportMethods,
    ...userMethods,
    toggleEventParent: function() {
      this.coborrowerFirstName = ''
      this.coborrowerMiddleName = ''
      this.coborrowerLastName = ''
      this.coborrowerSelected = !this.coborrowerSelected
    },

    getFloodReportAddons() {
      for (var i = 0; i < this.productAddOns.length; i++) {
        this.productAddons.push({
          value: this.productAddOns[i].productAddOnId,
          text: this.productAddOns[i].name,
          checked: this.productAddOns[i].defaultScope,
          disabled: !this.productAddOns[i].changeable,
        })
        if (this.productAddOns[i].defaultScope === true) {
          this.productAddon.push(this.productAddOns[i].productAddOnId)
        }
      }
    },
    getStateCode() {
      if (this.state !== '') {
        this.stateCode = this.states.find(
          (x) => x.value === Number(this.state)
        ).stateCode
      }
    },
    borrowerChange() {
      if (this.borrowerType === 1) {
        this.coborrowerSelected = false
      }
    },
    buildFloodReportRequest() {
      var borrower = {}
      var coBorrower = {}
      var business = {}
      let userInfo = this.$store.state.auth.currentUser.userInfo

      if (this.isCustRequestor) {
        this.customerUserId = userInfo.userId
      }

      if (this.borrowerType === 1) {
        business = JSON.stringify({
          Name: this.companyName,
        })
      } else {
        business = null
      }
      if (this.coborrowerSelected) {
        coBorrower = JSON.stringify({
          FirstName: this.coborrowerFirstName,
          MiddleName: this.coborrowerMiddleName,
          LastName: this.coborrowerLastName,
          BorrowerType: 1,
        })
      } else {
        coBorrower = null
      }
      if (this.borrowerType === 2) {
        borrower = JSON.stringify({
          FirstName: this.firstName,
          MiddleName: this.middleName,
          LastName: this.lastName,
          BorrowerType: 0,
        })
      } else {
        borrower = null
      }
      return JSON.stringify({
        ProductAddOnsId: this.productAddon,
        Borrower: borrower === null ? null : JSON.parse(borrower),
        Coborrower: coBorrower === null ? null : JSON.parse(coBorrower),
        PropertyAddress: {
          Street: this.streetAddress,
          City: this.cityName,
          StateId: this.state,
          StateCode: this.stateCode,
          Zip: this.zip,
        },
        Business: business === null ? null : JSON.parse(business),
        Contact: {
          PhoneNumber: this.phoneNumber === '' ? '' : this.phoneNumber,
        },
        UserId: userInfo.userId,
        ProductId: this.productId,
        OrderForUserId: this.customerUserId,
        OrderForCustomerId: this.customerId,
        LegalDescription: this.legaldescription,
        LoanIdentifier: this.loanIdentifier,
      })
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    onReportSubmit(selectedValue) {
      this.getStateCode()
      var isOrderReportComponentValid = false
      var isFloodReportComponentValid = false
      // let userInfo = this.$store.state.auth.currentUser.userInfo
      var that = this
      this.$parent.$parent.$validator.validateAll().then((response) => {
        isOrderReportComponentValid = response
        this.$validator.validate().then((response) => {
          if (this.isCustRequestor) {
            isOrderReportComponentValid = response
          }
          isFloodReportComponentValid = response
          if (isOrderReportComponentValid && isFloodReportComponentValid) {
            if ((that.firstName && that.lastName) || that.companyName !== '') {
              that.showSpinner = true
              that
                .fetchFloodReport({
                  jsonRequestString: that.buildFloodReportRequest(),
                })
                .then((response) => {
                  if (
                    response.data !== null &&
                    response.data.responseStatus === 1 &&
                    response.data.reportByteArray !== undefined
                  ) {
                    let url = common.downloadFile(
                      response.data.reportByteArray,
                      constant.contentType.pdf,
                      constant.products.FloodReport
                    )
                    this.$router.open({
                      name: 'pdfviewer',
                      query: {
                        url: url,
                      },
                    })
                    this.$emit('resetOrderReport')
                  } else if (
                    response.data.responseStatus === 3 ||
                    response.data.responseStatus === 5
                  ) {
                    alert(response.data.message)
                    window.location.reload()
                  } else if (
                    response.data.message !== '' &&
                    response.data.message !== null &&
                    response.data.message !== undefined
                  ) {
                    alert(response.data.message)
                  } else {
                    alert(constant.errorMessage)
                  }
                  this.showSpinner = false
                })
                .catch((error) => {
                  this.showSpinner = false
                  alert(constant.errorMessage)
                  // this.displayAlert = true
                  // this.alertMessage = constant.errorMessage
                  // this.showAlert()
                  this.errorLog = error
                })
            } else {
              alert('Please enter borrower name or company name.')
            }
          }
        })
      })
    },
  },
}
</script>

<template>
  <div>
    <BaseAlert
      v-if="displayAlert"
      class="w-25"
      :class="$style.alertMsgPosition"
    >
      {{ alertMessage }}
    </BaseAlert>
    <BaseSpinner v-if="showSpinner" />
    <b-row>
      <b-col sm="12 mt-4">
        <b-form-group class="mb-0">
          <b-form-checkbox
            v-for="option in productAddons"
            :key="option.value"
            v-model="productAddon"
            v-validate="'required'"
            :value="option.value"
            :checked="option.checked"
            :disabled="option.disabled"
            name="productAddon"
            inline
            >{{ option.text }}</b-form-checkbox
          >
        </b-form-group>
        <div v-show="errors.has('productAddon')" class="error"
          >Flood type is required</div
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="border-bottom pb-3" />
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="loanIdentifier"
          v-model="loanIdentifier"
          v-validate="'required'"
          validattor="^(?!')(?!`).*$"
          data-vv-as="Loan Identifier"
          type="text"
          maxlength="50"
          name="loanIdentifier"
          label-content="Loan Identifier"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('loanIdentifier'),
          }"
          :placeholder="placeholders.loanIdentifier"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('loanIdentifier') }} </div>
      </b-col>
      <b-col md="6">
        <BaseELabel mark-required label="Borrower Type" size="sm"/>

        <b-form-group>
          <b-form-radio-group
            :key="typeOption.id"
            v-model="borrowerType"
            :options="typeOption"
            class="mr-5"
            @change="borrowerChange"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="border-bottom pb-3" />
    </b-row>
    <b-row>
      <b-col v-if="borrowerType === 1" md="3">
        <BaseEInputText
          id="companyName"
          v-model="companyName"
          v-validate="'required'"
          data-vv-as="Company Name"
          type="text"
          name="companyName"
          maxlength="100"
          label-content="Company Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('companyName'),
          }"
          :placeholder="placeholders.companyName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('companyName') }} </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="borrowerType === 2" md="3">
        <BaseEInputText
          id="firstName"
          v-model="firstName"
          v-validate="{ required: true, regex: /^[A-Za-z0-9-]+$/ }"
          validattor="^[A-Za-z0-9-]+$"
          data-vv-as="First Name"
          type="text"
          name="firstName"
          maxlength="50"
          label-content="First Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('firstName'),
          }"
          :placeholder="placeholders.firstName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('firstName') }} </div>
      </b-col>
      <b-col v-if="borrowerType === 2" md="3">
        <BaseEInputText
          id="middleName"
          v-model="middleName"
          v-validate="{ required: false, regex: /^[A-Za-z0-9-]+$/ }"
          validattor="^[A-Za-z0-9-]+$"
          data-vv-as="Middle Name"
          type="text"
          name="middleName"
          maxlength="50"
          label-content="Middle Name"
          :class="{
            input: true,
            'is-danger': errors.has('middleName'),
          }"
          :placeholder="placeholders.middleName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('middleName') }} </div>
      </b-col>
      <b-col v-if="borrowerType === 2" md="3">
        <BaseEInputText
          id="lastName"
          v-model="lastName"
          v-validate="{
            required: true,
            regex: /^[A-Za-z0-9-]+$/,
          }"
          validattor="^[A-Za-z0-9-]+$"
          data-vv-as="Last Name"
          type="text"
          name="lastName"
          maxlength="50"
          label-content="Last Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('lastName'),
          }"
          :placeholder="placeholders.lastName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('lastName') }} </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="5">
        <BaseEInputText
          id="streetAddress"
          v-model="streetAddress"
          v-validate="'required'"
          data-vv-as="Street"
          type="text"
          name="streetAddress"
          maxlength="100"
          label-content="Street"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('street'),
          }"
          :placeholder="placeholders.streetAddress"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('streetAddress') }} </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="cityName"
          v-model="cityName"
          v-validate="{ required: true, regex: /^[A-Za-z -]+$/ }"
          validattor="^[A-Za-z -]+$"
          data-vv-as="City"
          type="text"
          name="cityName"
          maxlength="20"
          label-content="City"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('city'),
          }"
          :placeholder="placeholders.cityName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('cityName') }} </div>
      </b-col>
      <b-col md="2">
        <BaseELabel mark-required label="State" size="sm"/>

        <BaseDropdown
          v-model="state"
          v-validate="'required'"
          data-vv-as="State"
          :field-id="state"
          :options="states"
          class="mb-1"
          name="state"
          :placeholder="placeholders.state"
        ></BaseDropdown>
        <div class="error"> {{ errors.first('state') }} </div>
      </b-col>
      <b-col md="2">
        <BaseEInputText
          id="zip"
          v-model="zip"
          v-validate="{ required: true, regex: /^[0-9]{5}(?:-[0-9]{4})?$/ }"
          validattor="[0-9]"
          data-vv-as="Zip"
          maskker="(\d{5})(\d{4})"
          formatter="$1-$2"
          type="text"
          maxlength="10"
          name="zip"
          label-content="Zip"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('zip'),
          }"
          :placeholder="placeholders.zip"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('zip') }} </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="phoneNumber"
          v-model="phoneNumber"
          v-validate="{
            required: false,
            regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{3})(\d{4})"
          formatter="($1) $2-$3"
          data-vv-as="Phone #"
          type="text"
          maxlength="14"
          name="phoneNumber"
          label-content="Phone Number"
          :class="{
            input: true,
            'is-danger': errors.has('phoneNumber'),
          }"
          :placeholder="placeholders.phoneNumber"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('phoneNumber') }} </div>
      </b-col>
      <b-col md="9">
        <BaseEInputText
          id="legaldescription"
          v-model="legaldescription"
          data-vv-as="Legal Description"
          type="text"
          name="legaldescription"
          maxlength="300"
          label-content="Legal Description"
          :placeholder="placeholders.legaldescription"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('legaldescription') }}
        </div>
      </b-col>
    </b-row>
    <b-row v-if="borrowerType === 2">
      <b-col md="3">
        <BaseELabel label="Co-Borrower" size="sm"/>

        <BaseSwitch
          id="coborrowerSelected"
          v-model="coborrowerSelected"
          name="coborrowerSelected"
          class="float-left pt-2"
          checkedlbl="Yes"
          uncheckedlbl="No"
          :is-checked="false"
          @toggleEvent="toggleEventParent"
        />
        <!-- <span v-if="coborrowerSelected" :class="$style.statusCheck">Yes</span>
        <span v-else :class="$style.statusCheck">No</span> -->
      </b-col>
    </b-row>
    <b-row v-if="coborrowerSelected === true && borrowerType === 2">
      <b-col md="3">
        <BaseEInputText
          id="coborrowerFirstName"
          v-model="coborrowerFirstName"
          v-validate="{ required: true, regex: /^[A-Za-z0-9-]+$/ }"
          validattor="^[A-Za-z0-9-]+$"
          data-vv-as="First Name"
          type="text"
          name="coborrowerFirstName"
          maxlength="50"
          label-content="First Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('coborrowerFirstName'),
          }"
          :placeholder="placeholders.firstName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('coborrowerFirstName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="coborrowerMiddleName"
          v-model="coborrowerMiddleName"
          v-validate="{ required: false, regex: /^[A-Za-z0-9-]+$/ }"
          validattor="^[A-Za-z0-9-]+$"
          data-vv-as="Middle Name"
          type="text"
          name="coborrowerMiddleName"
          maxlength="50"
          label-content="Middle Name"
          :class="{
            input: true,
            'is-danger': errors.has('middleName'),
          }"
          :placeholder="placeholders.middleName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('coborrowerMiddleName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="coborrowerLastName"
          v-model="coborrowerLastName"
          v-validate="{ required: true, regex: /^[A-Za-z0-9-]+$/ }"
          validattor="^[A-Za-z0-9-]+$"
          data-vv-as="Last Name"
          type="text"
          name="coborrowerLastName"
          maxlength="50"
          label-content="Last Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('coborrowerLastName'),
          }"
          :placeholder="placeholders.lastName"
        ></BaseEInputText>
        <div class="error">{{ errors.first('coborrowerLastName') }}</div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="border-bottom pb-3" />
    </b-row>
    <b-row class="mt-4" align-h="center">
      <b-col md="1" class="p-0">
        <BaseEButton @click="onReportSubmit">
          Submit
        </BaseEButton>
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss" module>
@import '@design';
.status {
  margin: 0.625rem 0;
  font-size: $size-content-font;
  font-weight: $label-font-weight;
  color: $color-text-gray;
}
.labelHeader {
  font-size: $size-font-sub-header;
  font-weight: $heading-font-weight;
  color: $color-subheader;
}

.statusCheck {
  position: relative;
  top: 8px;
  padding-left: 11px;
  font-size: 16px;
  font-weight: bold;
  color: dodgerblue;
}
.alertMsgPosition {
  position: absolute;
  top: 350px;
  right: 0;
}
</style>
